import React, { Component } from "react";
import { MenuItem, Select, Button, DialogTitle, DialogActions } from "@mui/material";

import { Gap20 } from "js/react/components/Gap";
import { BeautifulDialog, DialogContent } from "js/react/components/Dialogs/BaseDialog";
import { GridBox, ScrollBox } from "js/react/components/LayoutGrid";
import { UserProfile } from "js/react/components/Avatar";

export class ConfirmInviteDialog extends Component {
    state = {
        permission: "write",
    }

    handleChangePermissions = event => {
        this.setState({
            permission: event.target.value
        });
    }

    handleAccept = async () => {
        const {
            callback,
            closeDialog,
        } = this.props;
        const {
            permission
        } = this.state;

        callback && callback(permission);
        closeDialog();
    }

    render() {
        const {
            title = "Add the following collaborators?",
            includeSubheader = true,
            hasPermissionEditing = false,
            users,
            closeDialog,
        } = this.props;
        const {
            permission,
        } = this.state;

        return (
            <BeautifulDialog id="confirmInvite" closeDialog={this.props.closeDialog}>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    {
                        (
                            includeSubheader ||
                            hasPermissionEditing
                        ) &&
                        <>
                            <label>
                                {
                                    hasPermissionEditing &&
                                    <>
                                        {users.length > 0 ? "These collaborators" : "Collaborators"} will have
                                        <Select
                                            value={permission}
                                            onChange={this.handleChangePermissions}
                                            variant="outlined"
                                            style={{ margin: "0px 10px" }}
                                        >
                                            <MenuItem value="read">View</MenuItem>
                                            <MenuItem value="write">Edit</MenuItem>
                                        </Select>
                                        access{users.length > 1 ? ":" : "."}
                                    </>
                                }
                                {
                                    !hasPermissionEditing &&
                                    <>
                                        {users.length > 0 ? "These collaborators" : "Collaborators"} will be invited{users.length > 1 ? ":" : "."}
                                    </>
                                }
                            </label>
                            <Gap20 />
                        </>
                    }
                    {users.length > 0 && <ScrollBox fillWidth style={{ maxHeight: 370 }}>
                        <GridBox rows>
                            {users.map(member => (
                                <UserProfile
                                    key={member.id}
                                    profile={member}
                                />
                            ))}
                        </GridBox>
                    </ScrollBox>}
                </DialogContent>
                <DialogActions>
                    <Button id="btnCancel" onClick={() => closeDialog()}>Cancel</Button>
                    <Button id="btnOk" color="primary" onClick={this.handleAccept}>Ok</Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}
